import Layout from "components/Layout";
import React from "react";
import SiteDataTable from "./components/SiteDataTable";

function Site() {
  return (
    <Layout title="현장 목록">
      <SiteDataTable />
    </Layout>
  );
}

export default Site;
